import { HubConnection } from '@microsoft/signalr'

export class CancellationToken {
  private readonly topic: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private readonly callback: (data: any) => void
  private readonly connection: HubConnection

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(topic: string, callback: (data: any) => void, connection: HubConnection) {
    this.topic = topic
    this.callback = callback
    this.connection = connection
  }

  public async cancel() {
    this.connection.off(`${this.topic}Recieved`, this.callback)
  }
}
